import { VCombobox } from 'vuetify/lib/components/VCombobox';

var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c(VCombobox,{staticClass:"mini",attrs:{"outlined":"","dense":"","hide-details":"auto","items":_vm.addresses,"item-text":_vm.addressLabel,"item-id":"id","value":_vm.value,"return-object":"","label":_vm.label ? _vm.label : ''},on:{"change":function($event){return _vm.$emit('change', $event)}}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }